import React from 'react';
import classnames from 'classnames';
import MoonIcon from 'images/icons/moon.svg?react-svg';
import { SecondarySmallUppercase, H3 } from 'scy/text';
import { mutedAccent } from 'scy/text/styles.mod.scss';
import { pageContainer, borderBox, textCenter } from 'scy/utils.mod.scss';
import { flex, column, centerContent } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function UncaughtErrorPage() {
  return (
    <section
      className={classnames(
        pageContainer,
        borderBox,
        margin.md,
        textCenter,
        flex,
        column,
        centerContent
      )}
    >
      <div className={classnames(mutedAccent, margin.md)}>
        <MoonIcon />
      </div>
      <SecondarySmallUppercase tag="h1" marginClass={classnames(margin.sm)}>
        500
      </SecondarySmallUppercase>
      <H3 marginClass={classnames(margin.sm, margin.tablet_md)}>
        Looks like our server had one too many cocktails…
        <br />
        we’ll be right back.
      </H3>
    </section>
  );
}
